// Copyright (c) 2022-2024. Sendanor <info@sendanor.fi>. All rights reserved.

import {
    CART_VIEW_CLASS_NAME
} from "../../../../core/constants/className";
import {
    T_CART_VIEW_TITLE,
    T_SITE_NAME
} from "../../../../core/constants/translation";
import {
    CART_ROUTE,
} from "../../../../core/constants/route";
import { CartArticle } from "../../common/cart/CartArticle";
import { useShoppingCart } from "../../../../../../io/hyperify/frontend/hooks/useShoppingCart";
import { useCartUpdatedEvent } from "../../../hooks/useCartUpdatedEvent";
import { useCallback } from "react";
import { LogService } from "../../../../../../io/hyperify/core/LogService";
import { TranslationFunction } from "../../../../../../io/hyperify/core/types/TranslationFunction";
import { SEODiv } from "../../common/seo/SEODiv";
import "./CartView.scss";

const LOG = LogService.createLogger('CartView');

export interface CartViewProps {
    readonly t: TranslationFunction;
    readonly className?: string;
}

export function CartView (props: CartViewProps) {

    const t: TranslationFunction = props?.t ?? ((key: string): string => key);
    const className = props?.className;
    const [cart, refreshCart] = useShoppingCart();
    const myRefreshCartCallback = useCallback(
        () => {
            LOG.debug(`Cart updated`);
            refreshCart();
        },
        [
            refreshCart
        ]
    );
    useCartUpdatedEvent(myRefreshCartCallback);

    return (
        <SEODiv className={CART_VIEW_CLASS_NAME + (className ? ` ${className}` : "")}
                path={CART_ROUTE}
                title={t(T_CART_VIEW_TITLE)}
                description={t(T_CART_VIEW_TITLE)}
                siteName={t(T_SITE_NAME)}
        >
            <CartArticle
                t={t}
                className={CART_VIEW_CLASS_NAME + '-body'}
                cart={cart}
            />
        </SEODiv>
    );
}
